import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpRespuesta } from '../models/http-respuesta.interface';
import { UsuarioSesion } from '../models/usuario-sesion.interface';

const SESSION_COOKIE = "sessiondistr";
const SESSION_CADUCIDAD_OUT = "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";

const ADMINISTRADOR = 1;
const EMPRESA = 2;

@Injectable({ providedIn: 'root' })
export class AuthService {

  private sesion: UsuarioSesion | null = null;

  constructor(private http: HttpClient) { }

  login(email: string, contrasena: string): Observable<HttpRespuesta<UsuarioSesion>> {
    return this.http.post<HttpRespuesta<UsuarioSesion>>(environment.api.sigin, { email, contrasena });
  }
  get isLoggedIn(): boolean {
    return this.sesion !== null;
  }
  get Session(): UsuarioSesion | null {
    return this.sesion;
  }
  get isEmpresa(): boolean {
    return this.sesion?.fk_rol === EMPRESA;
  }
  get isAdministrativo(): boolean {
    return this.sesion?.fk_rol === ADMINISTRADOR;
  }
  setNewSession(usuario: UsuarioSesion): void {
    this.setCookie(usuario);
    this.sesion = usuario;
  }
  setSessionOut(): void {
    document.cookie = SESSION_COOKIE + SESSION_CADUCIDAD_OUT;
    this.sesion = null;
  }
  setCookie(usuario: UsuarioSesion): void {
    let valor = JSON.stringify(usuario);
    document.cookie = SESSION_COOKIE + "=" + valor;
  }
  getCookie(cname: string): string {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";

  }

  sessionActive(): boolean {
    let session = this.getCookie(SESSION_COOKIE);
    if (session) {
      this.sesion = JSON.parse(session);
      return true;
    } else {
      return false;
    }
  }

}
